import { BergerLevrault, Instruction, LocalAuthority } from "../../model";
import { genericFetch } from './common-service';
import { apiBaseUrl } from "./config";
import { createLocalAuthorityRequestBody, createLocalAuthorityUpdateRequestBody } from "./factory";
import { getBaseHeader } from "./utils";

const LOCALAUTHORITIES = 'localauthorities'
const CHILDREN = 'children'

export function findAllLocalAuthorities() {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}`
    const init = {
        headers: getBaseHeader(true),
    }

    return genericFetch<LocalAuthority[]>(url, init)
}

export function findAllLocalAuthoritiesChildren(slug: string) {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${slug}/${CHILDREN}`
    const init = {
        headers: getBaseHeader(true),
    }

    return genericFetch<LocalAuthority[]>(url, init)
}

export function DeleteLocalAuthoritiesChildren(LA: any) {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${LA.parentSlug}/${CHILDREN}/${LA.slug}`
    const init = {
        headers: getBaseHeader(true),
        method: "DELETE"
    }

    return genericFetch<LocalAuthority[]>(url, init)
}



export function createLocalChildAuthority(
    localAuthority: LocalAuthority,
    slug: string,
    name: string,
    code: string,
    instruction: Instruction,
    bergerLevrault?: BergerLevrault,
    politicalApproach?: boolean
): Promise<LocalAuthority> {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${slug}/${CHILDREN}`
    const localAuthorityRB = createLocalAuthorityRequestBody(
        name, code, instruction, bergerLevrault, politicalApproach)
    const init: RequestInit = {
        body: JSON.stringify(localAuthorityRB),
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "POST"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function createLocalAuthority(
    name: string,
    code: string,
    instruction: Instruction,
    bergerLevrault?: BergerLevrault,
    politicalApproach?: boolean,
    monthlyCountersFillingReminder?: boolean,
    notificationAfterCountersImport?: boolean
): Promise<LocalAuthority> {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}`
    const localAuthorityRB = createLocalAuthorityRequestBody(
        name, code, instruction, bergerLevrault, politicalApproach, monthlyCountersFillingReminder, notificationAfterCountersImport)
    const init: RequestInit = {
        body: JSON.stringify(localAuthorityRB),
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "POST"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateLocalAuthority(localAuthority: LocalAuthority, name: string, code: string, bergerLevrault?: BergerLevrault, politicalApproach?: boolean,
    monthlyCountersFillingReminder?: boolean, notificationAfterCountersImport?: boolean) {
    const id = localAuthority.id
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${id}`
    const localAuthorityRB = createLocalAuthorityUpdateRequestBody(
        name, code, bergerLevrault, politicalApproach, monthlyCountersFillingReminder, notificationAfterCountersImport
    )
    const init = {
        body: JSON.stringify(localAuthorityRB),
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateLocalAuthorityChildren(localAuthority: LocalAuthority, name: string, code: string, bergerLevrault?: BergerLevrault, politicalApproach?: boolean,
    monthlyCountersFillingReminder?: boolean, notificationAfterCountersImport?: boolean) {
    const id = localAuthority.id
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${id}`
    const localAuthorityRB = createLocalAuthorityUpdateRequestBody(
        name, code, bergerLevrault, politicalApproach, monthlyCountersFillingReminder, notificationAfterCountersImport
    )
    const init = {
        body: JSON.stringify(localAuthorityRB),
        headers: {
            ...getBaseHeader(),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }

    return genericFetch<LocalAuthority>(url, init)
}



export function findLocalAuthorityByIdOrSlug(localAuthorityId) {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthorityId}`
    const init = {
        headers: getBaseHeader(true)
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateMaxDebtRefundPercentageOnCashFlow(
    localAuthority: LocalAuthority,
    maximumDebtRefund: number
): Promise<LocalAuthority> {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}`
    const body = JSON.stringify({ localAuthority: { maximumDebtRefund } })
    const init = {
        body,
        headers: {
            ...getBaseHeader(true),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateMaxDeleveragingYears(
    localAuthority: LocalAuthority,
    maximumDeleveragingYears: number
): Promise<LocalAuthority> {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}`
    const body = JSON.stringify({ localAuthority: { maximumDeleveragingYears } })
    const init = {
        body,
        headers: {
            ...getBaseHeader(true),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateMinGrossCashFlow(
    localAuthority: LocalAuthority,
    minimumGrossCashFlow: number
): Promise<LocalAuthority> {
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${localAuthority.id}`
    const body = JSON.stringify({ localAuthority: { minimumGrossCashFlow } })
    const init = {
        body,
        headers: {
            ...getBaseHeader(true),
            "Content-Type": "application/json"
        },
        method: "PUT"
    }

    return genericFetch<LocalAuthority>(url, init)
}

export function updateLocalAuthorityDebtMode(
    localAuthority: LocalAuthority,
    isDebtSimplified: boolean
) {
    const id = localAuthority.id;
    const url = `${apiBaseUrl}/${LOCALAUTHORITIES}/${id}/debt-mode`;

    const body = { localAuthority: { isDebtSimplified } };

    const init = {
        method: 'PUT',
        headers: {
            ...getBaseHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    };

    return genericFetch<LocalAuthority>(url, init);
}


// WEBPACK FOOTER //
// ./src/service/sfp/local-authorities-service-2.ts